/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-10-23 17:14:55
 **/
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import produce from "immer";

import { ChronoUtils } from "@/frameworks/libraries/utilities";
import { usePersistStore } from "@/frameworks/core/persistence";
import type { StateDispatch } from "./states";

const LOGTAG = "#States:Actions#";

export default class StatesActions implements StateDispatch {
	private static _instance: StatesActions | null = null;
	private constructor() {}
	public static get instance() {
		if (!StatesActions._instance) {
			StatesActions._instance = new StatesActions();
		}
		return StatesActions._instance;
	}

	// /**
	//  * Sets the authorization key in the state.
	//  *
	//  * @param {string} key - The authorization key to be set.
	//  * @return {void}
	//  */
	// public set_authorization_key(key: string): void {
	// 	usePersistStore.setState((state) =>
	// 		produce(state, (draft) => {
	// 			draft.states.authorization.ak = key;
	// 		})
	// 	);
	// }
	//
	// /**
	//  * Sets the refresh key for the authorization state.
	//  *
	//  * @param {string} key - The new refresh key to be set.
	//  * @return {void}
	//  */
	// public set_refresh_key(key: string): void {
	// 	usePersistStore.setState((state) =>
	// 		produce(state, (draft) => {
	// 			draft.states.authorization.rt = key;
	// 		})
	// 	);
	// }
	//
	// /**
	//  * Updates the user ID in the authorization state.
	//  *
	//  * @param {string} id - The new user ID to be set.
	//  * @return {void} This method does not return a value.
	//  */
	// public set_user_id(id: string): void {
	// 	usePersistStore.setState((state) =>
	// 		produce(state, (draft) => {
	// 			draft.states.authorization.id = id;
	// 		})
	// 	);
	// }

	/**
	 * Sets the automatic timezone adjustment feature.
	 *
	 * @param {boolean} value - Determines if the automatic timezone is enabled or disabled.
	 * @return {void}
	 */
	public set_auto_timezone(value: boolean): void {
		usePersistStore.setState((state) =>
			produce(state, (draft) => {
				draft.states.auto_timezone = value;
				if (value) {
					draft.states.timezone = ChronoUtils.guess_timezone;
				}
			})
		);
	}

	/**
	 * Sets the service mode.
	 * @param {string} value - The service mode to be set.
	 * @return {void}
	 */
	public set_service_mode(value: "3D_SPACE" | "MY_DESK"): void {
		usePersistStore.setState((state) =>
			produce(state, (draft) => {
				draft.states.service_mode = value;
			})
		);
	}

	public get_service_mode(): "3D_SPACE" | "MY_DESK" {
		return usePersistStore.getState().states.service_mode;
	}
}
